<template>
	<div id="aprovacaoGestor">
		<a-row type="flex" justify="space-between" align="bottom">
			<a-col :span="9">
				<a-row>
					<span>Usuário:</span>
				</a-row>
				<a-row>
					<a-select
						show-search
						option-filter-prop="children"
						style="width: 80%"
						@change="handleChangeUsuario"
						:value="valueUsuario"
						:disabled="loading"
						:allowClear="valueUsuario!=0"
						>
						<a-select-option v-for="usuario in usuarios" :key="usuario.idUsuario">
							{{usuario.nome}}
						</a-select-option>
					</a-select>
				</a-row>
			</a-col>
			<a-col :span="9">
				<a-row>
					<span>Perfil:</span>
				</a-row>
				<a-row>
					<a-select					
						style="width: 80%"
						@change="handleChangePerfilTribunal"
						:value="valuePerfilTribunal"
						:disabled="loading||valueUsuario==0"
						:allowClear="(valuePerfilTribunal!=0 && valuePerfilTribunal!=null)"
						>
						<a-select-option v-for="perfilTribunal in perfisTribunal" :key="perfilTribunal.idPerfilTribunal">
							{{perfilTribunal.nome}}
						</a-select-option>
					</a-select>
				</a-row>
			</a-col>
			<a-col :span="3" style="text-align: right;">
				<a-button
					type="primary"
					@click.stop.prevent="carregarContratosAprovGestor()"
					:disabled="loading"
				>
				Pesquisar</a-button>
			</a-col>
		</a-row>

		<a-row style="height: calc(100vh - 340px); overflow-y: auto; overflow-x: auto; border-top: solid 1px #e8e8e8; border-bottom: solid 1px #e8e8e8; min-height: 100px;">
			<a-table					
				:rowSelection="rowSelection"
				:columns="columns"
				:rowKey="record => record.idContrato"
				:dataSource="data"
				:loading="{spinning:loading, tip:'Carregando...'}"
				:pagination="false"
				size="middle"
			>
			</a-table>
		</a-row>
		<a-row type="flex" align="middle" style="margin-top: 15px;">
			<a-col :span="24">
				<a-row type="flex" justify="end" align="middle" :gutter="40">
					<a-col>
						<a-button
							style="width: 115px;"
							type="primary"
							@click.stop.prevent="aprovacaoGestor(true)"
							:disabled="loading||fonteSelRowsModal==null"
						>
						Aprovar</a-button>
					</a-col>
					<a-col>
						<a-button
							style="width: 115px;"
							type="primary"
							@click.stop.prevent="aprovacaoGestor(false)"
							:disabled="loading||fonteSelRowsModal==null"
						>
						Não Aprovar</a-button>
					</a-col>
				</a-row>
			</a-col>
		</a-row>
	</div>
</template>

<script>
import IntimacaoWebApi from "@/API/intimacaoWebApi";
import moment from "moment";
import { LOAD_QTDAPROVACAO } from "@/store/actions";
import { showNotificationError } from "@/util/showNotification";
import { showNotificationSucess } from "@/util/showNotification";
import Helpers from "@/util/Helpers";

const columns = [
	{
		title: "Usuário",
		dataIndex: "nomeUsuario",
		sorter: (a, b) => a.nomeUsuario.localeCompare(b.nomeUsuario),
		width: "20%",
		scopedSlots: { customRender: "nomeUsuario" }
	},
	{
		title: "Perfil",
		dataIndex: "nomePerfilTribunal",
		sorter: (a, b) => a.nomePerfilTribunal.localeCompare(b.nomePerfilTribunal),
		//width: "20%",
		scopedSlots: { customRender: "nomePerfilTribunal" }
	},
	{
		title: "Fonte",
		dataIndex: "nomeFonte",
		sorter: (a, b) => a.nomeFonte.localeCompare(b.nomeFonte),
		width: "20%",
		scopedSlots: { customRender: "nomeFonte" }
	},
	{
		title: "UF",
		dataIndex: "uf",
		sorter: (a, b) => a.uf.localeCompare(b.uf),
		width: "5%",
		scopedSlots: { customRender: "uf" }
	},
	{
		title: "Justiça",
		dataIndex: "justica",
		sorter: (a, b) => a.justica.localeCompare(b.justica),
		width: "10%",
		scopedSlots: { customRender: "justica" }
	},
	{
		title: "Sistema",
		dataIndex: "sistema",
		sorter: (a, b) => a.sistema.localeCompare(b.sistema),
		width: "10%",
		scopedSlots: { customRender: "sistema" }
	},
	{
		title: "Instância",
		dataIndex: "obs_grau",
		sorter: (a, b) => a.obs_grau.localeCompare(b.obs_grau),
		width: "5%",
		scopedSlots: { customRender: "obs_grau" }
	}
];

export default {	
	name: "aprovacaoGestor",
	props: ['teste'],
	data() {
		return {
			idTela: 6,
			data: [],
			loading: false,
			columns,
			usuarios: [],
			perfisTribunal: [],
			valueUsuario: 0,
			valuePerfilTribunal: null,
			idPerfilPortal: 0,
			idUsuarioPortal: 0,
			idClientePortal: null,
			fonteSelRowsModal: null,
			rowSelection: {
				type:'checkbox',
				onChange: (selectedRowKeys, selectedRows) => {					
					this.rowSelection.selectedRowKeys = selectedRowKeys;					
					this.fonteSelRowsModal = selectedRows.length == 0 ? null : selectedRows;
				},
				selectedRowKeys: [],
			},
		};
	},
	mounted() {
		this.idUsuarioPortal = this.$store.state.auth.idUser;		
		this.idPerfilPortal = this.$store.state.auth.idPerfilPortal;
		this.idClientePortal = this.$store.state.auth.idCliente;
		this.carregarUsuarios();		

		try {
			this.$root.loadingSpinner = true;
			setTimeout(x => {
				this.carregarContratosAprovGestor();
				this.$root.loadingSpinner = false;
			}, 2000);
		}
		catch (err) {
			this.$root.loadingSpinner = false;
		}
	},
	methods: {
		carregarUsuarios(){
			this.loading = true;
			IntimacaoWebApi.getUsersExibicao({ idCliente: this.idClientePortal }).then(res => {
				this.loading = false;
				if (res.data.statusCode != 200) {
					showNotificationError(this, "Aprovação Gestor", res.data.errorMessage);
					return;
				} else if (typeof res.data.result == "string") {
					showNotificationSucess(this, "Aprovação Gestor", res.data.result);
				} else {
					this.usuarios.push({ idUsuario: 0, nome: 'Todos' });
					this.usuarios.push.apply(this.usuarios, res.data.result.map(h => {
							return { idUsuario: h.idUsuario, nome: h.nome }
						}));
				}
			})
			.catch(res => {
				this.loading = false;
				showNotificationError(this, "Aprovação Gestor", "Erro ao tentar carregar usuários.");
			});
		},
		handleChangeUsuario(value) {
			this.data = [];
			this.perfisTribunal = [];			
			this.valuePerfilTribunal = null;
			this.valueUsuario = value == undefined ? 0 : value;
			if (this.valueUsuario != 0)
				this.getPerfilTribunalExibicaoUsuario(this.valueUsuario);
		},		
		getPerfilTribunalExibicaoUsuario(idUsuarioPortal){
			this.perfisTribunal = [];			
			IntimacaoWebApi.getPerfilTribunalExibicaoUsuario(idUsuarioPortal)
				.then(res => {
					if (res.data.statusCode != 200) {
						showNotificationError(this, "Aprovação Gestor", res.data.errorMessage);
						return;
					} else if (typeof res.data.result == "string") {
						showNotificationSucess(this, "Aprovação Gestor", res.data.result);
					} else {
						this.perfisTribunal.push({ idPerfilTribunal: 0, nome: 'Todos' });
						this.perfisTribunal.push.apply(this.perfisTribunal, res.data.result.map(h => {
								return { idPerfilTribunal: h.idPerfilTribunal, nome: h.nome }
							}));						
						this.valuePerfilTribunal = 0;
					}
				})
				.catch(res => {
					this.loading = false;
					showNotificationError(this, "Aprovação Gestor", "Erro ao tentar carregar perfis.");
				});
		},
		handleChangePerfilTribunal(value) {
			this.data = [];
			this.valuePerfilTribunal = value == undefined ? 0 : value;		
		},
		carregarContratosAprovGestor() {
			this.fonteSelRowsModal = null;
			this.rowSelection.selectedRowKeys = [];
			this.loading = true;
			IntimacaoWebApi.recuperarContratoAprovacaoGestorExibicao(this.valueUsuario, (this.valuePerfilTribunal==null ? 0 : this.valuePerfilTribunal), (this.idClientePortal==null ? 0 : this.idClientePortal))
				.then(res => {
					this.loading = false;
					if (res.data.statusCode != 200) {
						showNotificationError(this, "Aprovação Gestor", res.data.errorMessage);
						return;
					} else if (typeof res.data.result == "string") {
						showNotificationSucess(this, "Aprovação Gestor", res.data.result);
					} else {					
						this.data = res.data.result;
					}				
				})
				.catch(res => {
					this.loading = false;					
					showNotificationError(this, "Aprovação Gestor", "Erro ao tentar carregar fontes.");
				});
		},
		aprovacaoGestor(aprovado) {
			if (this.fonteSelRowsModal == null)
			{
				showNotificationError(this, "Aprovação Gestor", "Selecione uma fonte na tabela!");
				return;
			}
			
			const _this = this;
			const x = _this.$createElement;
			var msg = aprovado ? 'Confirma a aprovação da(s) fonte(s)?' : 'Confirma a NÃO aprovação da(s) fonte(s)?';
			this.$confirm({				
				title: x('div', {}, [
						x('p', msg),
					]),
				content: '',
				width: '25%',
				onOk() {
					_this.chamarAPIAprovacao(aprovado);
				},
				onCancel(){},
			});
		},
		chamarAPIAprovacao(aprovado){
			let listaIdContrato = this.fonteSelRowsModal.map(f => {
					return f.idContrato
				});
			this.loading = true;
			IntimacaoWebApi.aprovacaoGestor(listaIdContrato, aprovado, this.idUsuarioPortal)
				.then(res => {					
					this.loading = false;
					if (res.data.statusCode == 200) {
						showNotificationSucess(this, "Aprovação Gestor", res.data.result);
						this.pegarQtdAprovacaoGestor();
						this.carregarContratosAprovGestor();
					} else
						showNotificationError(this, "Aprovação Gestor", res.data.errorMessage);
				})
				.catch(res => {					
					this.loading = false;
					showNotificationError(this, "Aprovação Gestor", "Erro ao alterar fonte.");
				});
		},
		pegarQtdAprovacaoGestor() {
			return this.$store
				.dispatch(LOAD_QTDAPROVACAO, this.$store)
				// .then()
				.catch(erro => {
					showNotificationError(this, "Home", error.res.Message);
				});
		},
		formatarDataLocal(data, isDateTime, format) {
			return Helpers.formatarData(data, isDateTime, format);
		},
	},
};
</script>

<style scoped>
span {
	color: #000;
	font-family: "Segoe UI", "Segoe UI Emoji", "Segoe UI Symbol", "Courier New",
		Courier, monospace;
	font-weight: bold;
}

.tr-ant-select {
	margin: 0px 0px 10px 0px;
}

.ant-switch {
	margin: 10px 0px 10px 0px;
}

.ant-input-affix-wrapper {
	margin: 0px 0px 10px 0px;
} 

.danger {
	color: red;
}

.sucess {
	color: green;
}

.default {
	color: black;
}

.custom-filter-dropdown {
	padding: 8px;
	border-radius: 4px;
	background: #fff;
	box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}

.highlight {
	background-color: rgb(255, 192, 105);
	padding: 0px;
}

.cursor {
	cursor: pointer;
}

.cursor:hover {
  color: blue;
}
</style>

<style>
</style>